// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const BasisForSettlement = props =>
    <section className='basis-for-settlement'>
        <header>
            <FormattedMessage id='BASIS_FOR_SETTLEMENT'/>
        </header>
        <section>
            {props.basisForSettlement}
        </section>
    </section>;

BasisForSettlement.displayName = 'BasisForSettlement';
BasisForSettlement.propTypes = {
    basisForSettlement: PropTypes.string.isRequired
};

export default BasisForSettlement;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/basis-for-settlement.js